import { ReactElement } from "react";
import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import { Button, ButtonColorType } from "@/ui-components/commonComponents/Button/Button";

import style from "./style.module.css";

export interface IConfirmDisableTimerModal {
  isOpen: boolean;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
  children: ReactElement<any, any>;
}

export default function ConfirmDisableTimerModal({
  isOpen,
  isLoading = false,
  onCancel,
  onConfirm,
  children,
}: IConfirmDisableTimerModal) {
  return (
    <BasicModal
      autoHeight={true}
      isModalOpen={isOpen}
      handleCancel={onCancel}
      footer={
        <div className={style.actionButtons}>
          <Button onClick={onCancel} colorType={ButtonColorType.light}>
            cancel
          </Button>
          <Button isLoading={isLoading} onClick={onConfirm}>
            disable timer
          </Button>
        </div>
      }
    >
      <div className={style.modalContent}>{children}</div>
    </BasicModal>
  );
}
